import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/stores";
import { ReportItem } from "./types";
import { ReportService } from "./services";

interface TenantDailyReportWithdrawState {
  loading: boolean;
  items: ReportItem[];
}

const initialState: TenantDailyReportWithdrawState = {
  loading: false,
  items: [],
};

export const tenantDailyReportWithdrawSelects = {
  loading: (state: RootState) => state.tenantDailyReportWithdraw.loading,
  items: (state: RootState) => state.tenantDailyReportWithdraw.items,
};

export const tenantDailyReportWithdrawThunks = {
  list: createAsyncThunk("tenantDailyReportWithdraw/list", async () => {
    const res = await ReportService.dailyReportWithdraw().run();
    return res.data.msg;
  }),
};

export const tenantDailyReportWithdrawSlice = createSlice({
  name: "tenantDailyReportWithdraw",
  initialState,
  reducers: {
    // setQueryParams: (state, action: PayloadAction<TransferQueryParams>) => {
    //   state.queryParams = action.payload;
    // },
  },
  extraReducers: (builder) => {
    builder.addCase(tenantDailyReportWithdrawThunks.list.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      tenantDailyReportWithdrawThunks.list.fulfilled,
      (state, action) => {
        state.loading = false;
        state.items = action.payload.items;
      }
    );
    builder.addCase(tenantDailyReportWithdrawThunks.list.rejected, (state) => {
      state.loading = false;
      state.items = [];
    });
  },
});

export const tenantDailyReportWithdrawActions =
  tenantDailyReportWithdrawSlice.actions;
